import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedF5NetworksApp from "./EmbeddedF5NetworksApp";
const F5NetworksApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("f5networks.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("f5networks.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "f5networks.app.requirement",
      components: { externalLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://www.f5.com/trials/big-ip-virtual-edition" }) }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedF5NetworksApp, null));
};
export default F5NetworksApp;
